import React from "react";
import SplitNumber from "./SplitNumber";
import { IconBasket1 } from "../../assets/icons";
function AddToBasketButton({ onClick, price }) {
  const handleShowModal = () => {
    onClick(true);
  };
  return (
    <button
      className="btn btn-success d-flex align-items-center w-100 p-0 btn-with-icon mt-1"
      onClick={handleShowModal}
    >
      <div className="border-end border-success icon-span ">
        <IconBasket1 fillColor="#fff" />
      </div>
      <div className=" text-center flex-fill">
        <span className="fs-101">
          <SplitNumber number={price} />
        </span>

        <span className="fs-085 ps-1">تومان</span>
      </div>
    </button>
  );
}
export default AddToBasketButton;
